import { removeItemFromBasket, selectBasketIsEmpty, selectBasketPaymentInProgress } from 'containers/OrderDetails/basketSlice'
import ConfirmationPopup from 'components/popups/ConfirmationPopup'
import { useReduxDispatch, useReduxSelector } from 'store'
import { ReactComponent as Back } from 'assets/back.svg'
import TimerProvider from './context/Timer/Provider'
import LoginPopup from 'containers/Login/LoginPopup'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import { selectLightTheme } from '../../appSlice'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import BasketTitle from './basket/Title'
import BasketPopup from './basket/Popup'
import React, { useState } from 'react'
import BasketIcon from './basket/Icon'
import './style.scss'

interface HeaderProps {
  dark?: boolean
  white?: boolean
  flying?: boolean
  rounded?: boolean
  backAction?: basic.BasicFunc
}

type Popup = {
  type: 'removeCartPosition'
  cartId: string
} | string

const Header: React.FC<HeaderProps> = ({ dark = false, white = false, flying = false, rounded = false, backAction }) => {
  const [bartekMode, setBartekMode] = useState(false)
  const lightTheme = useReduxSelector(selectLightTheme)
  const basketIsEmpty = useReduxSelector(selectBasketIsEmpty)
  const paymentInProgress = useReduxSelector(selectBasketPaymentInProgress)
  const { popup, openPopup } = usePopupState<Popup>()

  const { push, replace, goBack, location: { pathname } } = useHistory()
  const { t } = useTranslation('basket')
  const dispatch = useReduxDispatch()

  const isBasketExpanded = popup === 'basket'
  const showBasketTitle = !basketIsEmpty && !paymentInProgress && !pathname.includes('map')

  return (
    <TimerProvider>
      <header className={`--${lightTheme ? 'light' : 'dark'}${dark ? ' --black' : white ? ' --white' : ''}${flying ? ' --flying' : ''}${rounded ? ' --rounded' : ''}`}>
        <div className='group'>
          {(bartekMode && isBasketExpanded)
            ? <div className='s36' />
            : !pathname.match(/^\/(|chat|dashboard|help|account)$/) ? <div
              className='header__back'
              onClick={() => {
                backAction ? backAction() : window.history ? goBack() : replace('/')
              }}>
              <Back />
            </div>
              : null}

          {!flying && <div
            className='header__logo'
            onClick={() => {
              if (isBasketExpanded) setBartekMode(bm => !bm)
              else push('/')
            }}>
            {bartekMode && isBasketExpanded
              ? <span>{t('basket')}</span>
              : <i className='icon icon--logo s24' />}
          </div>}

          {basketIsEmpty
            ? <i
              className='icon icon--menu s32'
              onClick={() => {
                push(pathname, LOCATION_STATES.menu)
              }}
            />
            : bartekMode && isBasketExpanded
              ? <i
                className='icon icon--close s32'
                onClick={goBack}
              />
              : <BasketIcon
                action={() => {
                  if (paymentInProgress) return
                  if (isBasketExpanded) goBack()
                  else openPopup('basket')
                }}
              />}
        </div>
        {showBasketTitle && <BasketTitle />}
      </header>
      {isBasketExpanded && <BasketPopup />}
      {popup === 'login' && <LoginPopup />}
      {typeof popup === 'object' && popup.type === 'removeCartPosition' && <ConfirmationPopup
        okAction={() => {
          dispatch(removeItemFromBasket({ removeIdentifiers: [popup.cartId] }))
          goBack()
        }}
      />}
    </TimerProvider>
  )
}

export default Header